import {
  DeviceIcon,
  EventIcon,
  HomeIcon,
  ImportIcon,
  ExportIcon,
  PeopleIcon,
  PresetIcon,
  VenueIcon,
  SettingsIcon,
  UserIcon,
} from "components/ui/icons";

const commonNavConfig = [
  { href: "/profile", icon: UserIcon, title: "My Profile" },
  {
    href: "/settings/general",
    icon: SettingsIcon,
    title: "Settings",
  },
];

export const regularUserNavConfig = [
  {
    section: null,
    items: [
      { href: "/", icon: HomeIcon, title: "Home" },
      { href: "/events", icon: EventIcon, title: "Events" },
      { href: "/devices", icon: DeviceIcon, title: "My Devices" },
      { href: "/tracks", icon: VenueIcon, title: "Tracks" },
      { href: "/imports", icon: ImportIcon, title: "Imports" },
      {
        href: "/exports",
        icon: ExportIcon,
        title: "Exports",
        badge: "Pro",
        badgeFeature: "export_csv_data_logs",
      },
      ...commonNavConfig,
    ],
  },
];

export const superuserNavConfig = [
  {
    section: null,
    items: [
      { href: "/admin/home", icon: HomeIcon, title: "Home" },
      { href: "/admin/devices", icon: DeviceIcon, title: "Devices" },
      { href: "/admin/events", icon: EventIcon, title: "Events" },
      {
        href: "/admin/presets",
        icon: PresetIcon,
        title: "Presets",
      },
      {
        href: "/admin/users",
        icon: PeopleIcon,
        title: "User Admin",
      },
      {
        href: "/admin/venues",
        icon: VenueIcon,
        title: "Venues",
      },
      {
        href: "/admin/imports",
        icon: ImportIcon,
        title: "Imports",
      },
      {
        href: "/admin/exports",
        icon: ExportIcon,
        title: "Exports",
      },
      {
        href: "/admin/public-venue-export",
        icon: ImportIcon,
        title: "Public exports",
      },
      ...commonNavConfig,
    ],
  },
];
